import { MiscUtil } from './MiscUtil';
import { TypeUtil } from './TypeUtil';

class Param {
  public static SuppressAlerts: boolean = false;

  public static VerifyValue(param: Object, paramName: string): void {
    if (MiscUtil.IsNullOrUndefined(param)) {
      let ex = Param.CreateArgumentNullOrUndefinedException(paramName);
      Param.ShowParameterAlert(ex);
      throw ex;
    }
  }

  public static CreateArgumentNullOrUndefinedException(paramName: string): DOMException {
    let ex = new DOMException(`{paramName} is null or undefined`);
    TypeUtil.SetField(ex, paramName, paramName);
    return ex;
  }

  public static ShowParameterAlert(ex: DOMException): void {
    if (this.SuppressAlerts) {
      return;
    }

    // this try/catch block is so we can get the stack trace to display in the alert dialog
    try {
      throw ex;
    } catch (exceptionWithStack) {
      window.alert(Param.FormatExceptionMessage(exceptionWithStack));
    }
  }

  public static FormatExceptionMessage(ex: DOMException): string {
    let message = '';

    // tslint:disable-next-line:no-any whitespace
    let stack = (<any>ex).stack;
    if (!MiscUtil.IsNullOrUndefined(stack)) {
      message = stack;
    } else {
      message = ex.message;
    }

    return message;
  }
}

export { Param };
